module.exports = __webpack_public_path__ + "img/metalLongBackground.bf65fc3a.png";